export default [
  {
    path: '/lead',
    name: 'lead',
    component: () => import('@/views/menu/lead/lead.vue'),
    meta: {
      pageTitle: 'لیدها و درخواست‌ها',
      action: 'show',
      resource: 'LeadManager',
    },
  },
  {
    path: '/lead/add',
    name: 'addlead',
    component: () => import('@/views/menu/lead/leaddetails.vue'),
    meta: {
      pageTitle: 'ثبت لید جدید',
      action: 'show',
      resource: 'LeadManager',
      navActiveLink: 'lead',
      breadcrumb: [
        { text: 'لیدها', to: { name: 'lead' } },
        { text: 'ثبت لید جدید', active: true },
      ],
    },
  },
  {
    path: '/lead/:id',
    name: 'updatelead',
    component: () => import('@/views/menu/lead/leaddetails.vue'),
    meta: {
      pageTitle: 'جزئیات و پیگیری لید',
      action: 'show',
      resource: 'LeadManager',
      navActiveLink: 'lead',
      breadcrumb: [
        { text: 'لیدها', to: { name: 'lead' } },
        { text: 'جزئیات لید', active: true },
      ],
    },
  },
]
